import { buildNovaBracket, buildNovaSchedule } from '../mlbb/novaBracketEngine';

export const SCENES = { combined: 'Большое колесо + компактные группы', wheel: 'Главный экран · большое колесо', groups: 'Только группы', schedule: 'Только расписание', brand: 'Логотип федерации' };
export const SCREEN_LINKS = [
  ['Автоматически · весь экран', '?screen=auto'],
  ['Главный · большое колесо · 5760 × 2160', '?screen=center&view=wheel'],
  ['Центральный · колесо + компактные группы', '?screen=center&view=combined'],
  ['Квадратный · 2000 × 2000', '?screen=square&view=combined'],
  ['Боковые / задние · логотип', '?screen=square&view=brand'],
  ['Боковые / задние · крупные группы', '?screen=square&view=groups'],
  ['Квадратный · расписание', '?screen=square&view=schedule'],
  ['Центральный · по команде режиссёра', '?screen=center'],
  ['Квадратный · по команде режиссёра', '?screen=square'],
  ...[1, 2, 3].map((panel) => [`Центр: панель ${panel} из 3 · 1920 × 2160`, `?screen=panel&panel=${panel}&view=combined`]),
];

export function drawLayout(search = '', width = 1920, height = 1080) {
  const params = new URLSearchParams(search);
  const screen = ['center', 'square', 'panel'].includes(params.get('screen')) ? params.get('screen') : 'auto';
  const square = screen === 'square' || (screen === 'auto' && width / height < 1.4);
  return { screen, square, width: square ? 1000 : 1920, height: square ? 1000 : 720,
    panel: Math.max(1, Math.min(3, Number(params.get('panel')) || 1)),
    scene: Object.keys(SCENES).includes(params.get('view')) ? params.get('view') : null,
    clean: ['auto', 'center', 'square', 'panel'].includes(params.get('screen')), calibration: params.get('calibration') === '1' };
}

export function drawViewport(layout, width, height) {
  const viewportWidth = Math.max(1, width);
  const viewportHeight = Math.max(1, height);
  const panels = layout.screen === 'panel' ? 3 : 1;
  const scale = Math.min(viewportWidth * panels / layout.width, viewportHeight / layout.height);
  // Grow the table's canvas to fill the signal; keep text and logos uniformly scaled.
  return { width: viewportWidth * panels / scale, height: viewportHeight / scale, scale,
    offset: panels === 3 ? -(layout.panel - 1) * viewportWidth : 0 };
}

export function drawSchedule(data) {
  if (!data) return [];
  // Keep the selected seed positions while the draw still has empty slots.
  const groups = data.draw?.phase === 'drawing' ? data.draw.slots.map((slots, gi) => ({
    id: String(gi + 1), teams: slots.map((name, si) => name || `__draw_pending_${gi}_${si}`),
  })) : data.tour.groups;
  const bracket = buildNovaBracket(groups, data.results || {}, { preliminary: data.tour.bracketPreliminary === true });
  const name = (id, source) => bracket.names[id]?.startsWith('__draw_pending_') ? 'Ожидает жеребьёвки' : bracket.names[id] || sourceLabel(source);
  return buildNovaSchedule(bracket, data.tour.matchSchedule || {}).map((match) => ({ ...match,
    teamA: name(match.a, match.aSource),
    teamB: name(match.b, match.bSource),
  })).sort((a, b) => a.day - b.day || a.time.localeCompare(b.time) || a.stream - b.stream);
}

function sourceLabel(source) {
  if (!source.match) return 'Ожидает жеребьёвки';
  const codes = { p: 'предв.', w1: 'В1', w2: 'В2', wf: 'ВФ', l1: 'Н1', l2: 'Н2', lf: 'НФ' };
  return `${source.outcome === 'loser' ? 'Проигравший' : 'Победитель'} ${codes[source.match.split('-').pop()] || ''}`;
}

export function dayLabel(date, day) {
  if (!date) return `День ${day}`;
  const instant = new Date(`${date}T12:00:00+05:00`);
  instant.setUTCDate(instant.getUTCDate() + day - 1);
  return new Intl.DateTimeFormat('ru', { timeZone: 'Asia/Almaty', day: 'numeric', month: 'short' }).format(instant);
}
